import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query distributionNotesById($id: MongoID!) {
    cat {
      distribution {
        byId(_id: $id) {
          _id
          notes
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type DistributionNotesById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distribution']>['byId']>

const useDistributionNotesById = (id: string): DistributionNotesById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distribution = data?.cat?.distribution?.byId ?? undefined
  return distribution
}

export { useDistributionNotesById, document as distributionNotesByIdDocument }
